import UiElement from '../../../shared/ui-element/ui-element';
import analytics, {events} from '../../../shared/analytics';

class SignupFormStepPassword extends UiElement {
  ui = {
    inputPassword: '.js-password-input',
    togglePasswordButton: '.js-toggle-password',
    emailPlaceholder: '.js-password-step-email-placeholder',
    passwordErrorPlaceholder: '.js-password-error-msg',
    backButton: '.js-password-step-back-btn',
    retypeButton: '.js-password-step-retype-bth',
  };

  events = {
    'invalid @ui.inputPassword': 'handlePasswordInputValidation',
    'submit @rootElement': 'handleFormStepSubmit',
    'click @ui.togglePasswordButton': 'togglePasswordDisplaying',
    'click @ui.backButton': 'handleBackButtonClick',
    'click @ui.retypeButton': 'handleRetypeButtonClick',
  };

  constructor(options = {}) {
    super({rootElement: '#signup-form-step-password'});

    this.onSubmit = options.onSubmit;
    this.onRetypeButtonClick = options.onRetypeButtonClick;
    this.onBackButtonClick = options.onBackButtonClick;
  }

  showPasswordFieldError(errorText) {
    this.ui.passwordErrorPlaceholder.textContent = errorText;
    this.ui.inputPassword.classList.add('form-group__form-control_invalid');
  }

  hidePasswordFieldError() {
    this.ui.inputPassword.classList.remove('form-group__form-control_invalid');
  }

  updateEmailPlaceholder(email) {
    this.ui.emailPlaceholder.textContent = email;
  }

  togglePasswordDisplaying(e) {
    const button = e.target;

    if (this.ui.inputPassword.type === 'password') {
      this.ui.inputPassword.type = 'text';
      button.setAttribute('aria-label', button.dataset.hideTextAriaLabel);
      button.textContent = button.dataset.hideText;
    } else {
      this.ui.inputPassword.type = 'password';
      button.setAttribute('aria-label', button.dataset.showTextAriaLabel);
      button.textContent = button.dataset.showText;
    }
  }

  handleRetypeButtonClick() {
    this.onRetypeButtonClick();
  }

  handleBackButtonClick() {
    this.onBackButtonClick();
  }

  handlePasswordInputValidation(e) {
    e.preventDefault();
    const passwordInput = this.ui.inputPassword;

    if (passwordInput.validity.valueMissing) {
      this.showPasswordFieldError(passwordInput.dataset.errorEmpty);
      return;
    }

    if (passwordInput.validity.tooShort) {
      this.showPasswordFieldError(passwordInput.dataset.errorShort);
    }
  }

  handleFormStepSubmit(e) {
    e.preventDefault();
    if (!this.rootElement.checkValidity()) {
      return;
    }

    const password = e.currentTarget.elements.password.value;
    analytics.trackEvent(events.SIGNUP_FORM_STEP_PASSWORD);
    this.onSubmit({password});
    this.hidePasswordFieldError();
  }
}

export default SignupFormStepPassword;
